import { InjectionToken } from '@angular/core';

import { UiConfiguration } from '../services';
export const UI_CONFIGURATION_TOKEN = new InjectionToken<UiConfiguration>('UI_CONFIGURATION_TOKEN');
